import { Box } from '@mui/material'
import { IoIosArrowDroprightCircle, IoIosArrowDropleftCircle } from 'react-icons/io'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import {
  ImageWrap,
  ModalImageArea,
  NextButton,
  Paging,
  PrevButton,
} from './ContainerImagesEditModalImage.styles'
import { DeleteCheckbox } from '~/src/components/atoms/ContainerOrder/images/DeleteCheckbox'
import { IImage } from '~/src/repositories/Container/schema/IImage'

export const ContainerImagesEditModalImage: React.FC<{
  containerImages: IImage[]
  deleteIds: string[]
  setDeleteIds: Dispatch<SetStateAction<string[]>>
}> = ({ containerImages, deleteIds, setDeleteIds }): JSX.Element => {
  const [indexImage, setIndexImage] = useState<number>(0)
  const [showImages, setShowImages] = useState<IImage[]>([])
  const handleNextImage = () => {
    setIndexImage(indexImage + 1)
  }
  const handlePrevImage = () => {
    setIndexImage(indexImage - 1)
  }

  const imageCount = containerImages.length
  const pageCount = Math.floor(imageCount / 24) === 0 ? 1 : Math.floor(imageCount / 24) + 1
  useEffect(() => {
    const startIndex = indexImage * 24
    const endIndex = startIndex + 24

    const newShowImages = containerImages
      .map((image: IImage, index: number) => {
        if (startIndex <= index && index < endIndex) {
          return image
        }
      })
      .filter((image: IImage | undefined) => image) as IImage[]

    setShowImages(newShowImages)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indexImage])

  return (
    <>
      {imageCount > 0 && (
        <>
          <ModalImageArea>
            {showImages.map((data: IImage) => (
              <ImageWrap key={`${pageCount}-${data.id}`}>
                <Box
                  key={`img-${pageCount}-${data.id}`}
                  component="img"
                  sx={{ width: '94.67px', height: '94.67px', objectFit: 'cover' }}
                  src={data.file.url}
                  alt={data.file.filename}
                />
                <DeleteCheckbox data={data} deleteIds={deleteIds} setDeleteIds={setDeleteIds} />
              </ImageWrap>
            ))}
          </ModalImageArea>

          <Paging>
            <PrevButton disabled={indexImage === 0} onClick={handlePrevImage}>
              <IoIosArrowDropleftCircle size={24} color={'#222'} />
            </PrevButton>
            {indexImage + 1}/{pageCount}
            <NextButton disabled={indexImage === pageCount - 1} onClick={handleNextImage}>
              <IoIosArrowDroprightCircle size={24} color={'#222'} />
            </NextButton>
          </Paging>
        </>
      )}
    </>
  )
}
